import { Skeleton } from '@openedx/paragon';
import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';
import { ElementClicked, elementEvents, ElementType } from 'helpers/eventing';
import { getIsCTADisabled, useAppSelector } from 'store';
import { useCart, usePayPalOptions } from 'frontastic/hooks';

export const PayPalButton = () => {
  const { data } = useCart();
  const { createOrder, onApprove, onCancel, onError } = usePayPalOptions();
  const [{ isPending: isPayPalButtonLoading }] = usePayPalScriptReducer();
  const isCTADisabled = useAppSelector(getIsCTADisabled);

  const paypalTagularElement: ElementClicked['webElement'] = {
    elementType: ElementType.Button,
    name: 'paypal-cta',
    text: 'PayPal',
    htmlId: 'paypal-click',
    location: 'checkout',
  };

  const { elementClicked: paypalElementClicked } = elementEvents({
    webElement: paypalTagularElement,
  });

  const handlePaypalElementClicked = () => paypalElementClicked();

  if (isPayPalButtonLoading) {
    return <Skeleton className="pb-2.5 pt-3" />;
  }

  return (
    <PayPalButtons
      disabled={isCTADisabled}
      style={{
        height: 44,
        shape: 'pill', // Makes the button fully rounded
        color: 'gold', // Closest to #FFC43A
        // PayPal SDK does not support custom borderRadius, but 'pill' is fully rounded
      }}
      createOrder={createOrder}
      onApprove={onApprove}
      onCancel={onCancel}
      onClick={handlePaypalElementClicked}
      onError={onError}
      forceReRender={[data?.cartId, data?.cartVersion]}
    />
  );
};
